import { render, staticRenderFns } from "./AssignmentPopup.vue?vue&type=template&id=2cdd9f6f&scoped=true&"
import script from "./AssignmentPopup.vue?vue&type=script&lang=js&"
export * from "./AssignmentPopup.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPopup.vue?vue&type=style&index=0&id=2cdd9f6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd9f6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
